import React, { useState } from "react";
import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import { setStaffActive } from "../../../../services/StaffSupabaseService";
import { useLocalization } from "../../../../context/LocalizeContextProvider";

/**
 * Confirmation modal for hard activating / deactivating a staff account.
 * Calls ehealth.api2_set_staff_active (service-clinic PR #1).
 */
export default function ModalStaffActive({
  visible = false,
  staff = null,
  // staff: { id, name, nextActive }
  handleClose = () => undefined,
  onSuccess = () => undefined,
}) {
  const localize = useLocalization();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const nextActive = staff?.nextActive ?? true;

  const handleConfirm = async () => {
    setIsLoading(true);
    setError(null);
    const res = await setStaffActive(staff.id, nextActive);
    setIsLoading(false);
    if (res.status !== 200) {
      setError(res.error?.message || localize.getText("generalError"));
      return;
    }
    handleClose();
    onSuccess();
  };

  return (
    <Modal
      visible={visible}
      handleHideModal={handleClose}
      title={
        nextActive
          ? localize.getText("reactivateStaffTitle")
          : localize.getText("deactivateStaffTitle")
      }
    >
      <p>
        {nextActive
          ? localize
              .getText("reactivateStaffMessage")
              .replace("{itemName}", staff?.name ?? "")
          : localize
              .getText("deactivateStaffWarning")
              .replace("{itemName}", staff?.name ?? "")}
      </p>
      {error && (
        <div
          className="alert alert-danger mt-3 mb-0"
          role="alert"
          style={{ fontSize: "0.9rem" }}
        >
          {error}
        </div>
      )}
      <div className="d-flex justify-content-end gap-2 mt-4">
        <Button
          label={localize.getText("cancel")}
          variant="secondary"
          onClick={handleClose}
          disabled={isLoading}
        />
        <Button
          label={
            isLoading
              ? "..."
              : nextActive
              ? localize.getText("activate")
              : localize.getText("deactivate")
          }
          variant={nextActive ? "success" : "danger"}
          onClick={handleConfirm}
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
}
